var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaySkipBackicon = function SvgPlaySkipBackicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.336 10.826 8.854-5.297a1.43 1.43 0 0 1 1.457-.018 1.58 1.58 0 0 1 .786 1.381v3.706l8.47-5.07a1.43 1.43 0 0 1 1.458-.019 1.58 1.58 0 0 1 .786 1.382V17.25a1.58 1.58 0 0 1-.786 1.382 1.43 1.43 0 0 1-1.457-.018l-8.471-5.073v3.707a1.58 1.58 0 0 1-.786 1.384 1.43 1.43 0 0 1-1.457-.018l-8.854-5.297a1.465 1.465 0 0 1 0-2.485z"
  })));
};
export default SvgPlaySkipBackicon;